import moment from "moment";
import DOMPurify from "dompurify";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export const successMsg = (title = "Success", message = "Save Successfully", type = "success") => {
    ElNotification({
        title: title,
        message: message,
        type: type,
    });
};

export const errorMsg = () => {
    ElMessage({
        message: "Unable to Save",
        type: "error",
    });
};

export const dateFormate = (date, format = "DD MMM YYYY") => {
    if (date) return moment(date).format(format);
};

export const safeHtml = (html) => {
    return DOMPurify.sanitize(html);
};

export const safeFileUrl = (path) => {
    if (!path || typeof path !== "string") {
        return "";
    }

    const trimmedPath = path.trim();
    if (!trimmedPath) {
        return "";
    }

    const lowerPath = trimmedPath.toLowerCase();
    if (/^(javascript|data|vbscript|file):/.test(lowerPath)) {
        return "";
    }

    try {
        const url = new URL(trimmedPath, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith("/storage/")) {
            return "";
        }

        return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
        return "";
    }
};

export const isPdfFileUrl = (path) => /\.pdf$/i.test(safeFileUrl(path));

export const isImageFileUrl = (path) => /\.(jpg|jpeg|png|gif|webp)$/i.test(safeFileUrl(path));

export const secureLetterFileUrl = (letterId, download = false) => {
    if (!letterId) {
        return "";
    }

    return `/api/letter/${letterId}/file${download ? "?download=1" : ""}`;
};

export const secureLetterAttachmentUrl = (fileId, download = false) => {
    if (!fileId) {
        return "";
    }

    return `/api/letter-file/${fileId}/open${download ? "?download=1" : ""}`;
};

export const secureArchiveFileUrl = (fileId, download = false) => {
    if (!fileId) {
        return "";
    }

    return `/api/file/archive-item/${fileId}/open${download ? "?download=1" : ""}`;
};
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (typeof time === "string") {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time);
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), "/");
            }
        }

        if (typeof time === "number" && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        return value.toString().padStart(2, "0");
    });
    return time_str;
}

export function formatJson(filterVal, jsonData) {
    return jsonData.map((v) =>
        filterVal.map((j) => {
            if (j === "timestamp") {
                return parseTime(v[j]);
            } else {
                return v[j];
            }
        }),
    );
}

const signBlockHtml = (x, user, approvals) => {
    if (x == 0) return `<div class="pt-3"></div>`;
    else if (approvals.length - 1 == x) {
        return `<div class="pt-3">
            <b>
                <u>${user.appointment_bangla}</u>
            </b>
            <p class="pt-20">অনুমোদন দেয়া হলো / হলো না</p>
        </div>`;
    } else {
        return `<div class="pt-3">
            <b>
                <u>${user.appointment_bangla}</u>
            </b>
            <p class="pt-20">আপনার সদয় অনুমোদনের জন্য উপস্থাপন করা হলো</p>
        </div>`;
    }
};

export const approvalsHtml = (rows = [], date = "") => {
    return rows
        .map((user, i) => {
            // console.log(`Rendering approval ${index + 1}: ${user}`);
            return `
                ${signBlockHtml(i, user, rows)}
                <div class="" style="margin-left: 120mm; margin-top: 30px">
                    <div>
                        <div>${user.name_bangla}</div>
                        <div>${user.rank_bangla}</div>
                        <div>${user.appointment_bangla}</div>
                        <br />
                        <p class="">. . . . ${monthYearBangla(date)}</p>
                    </div>
                </div>

               
                ${i != rows.length - 1 ? `<div class='text-center text-bold mt-3'><u>${serBangla(i + 3)}</u></div>` : ""}
                `;
        })
        .join("");
};

export const details = (row, approvals) => {
    let htmlString = `<div class="note-sheet">
                    <div class='note-sheet-header'>
                        <div class="text-bold">প্রাক অনুমোদন</div>
                        <div> ${row.company_address}</div>
                        <div>(${row.company_name})</div>
                    </div>
                    <div class="editor-sheet">
                    <div class='editor-sheet-border'>
                    <div class="mb-2">${row.digital_no}/${dateFormatBD(row.date, "2-digit", "2-digit")}/(হিসাব)/${serBangla(row.id)}</div>
                    <div class="mb-2">
                        ${row.title}
                    </div>
                    <div class="mb-2 text-center text-bold"><u>১</u></div>
                    <div class="mb-2">
                        ১। ${row.company_address} ${row.company_name} কর্তৃক নিম্ন বর্ণিত দ্রবসামগ্রী ক্রয় বাবদ সর্বমোট ${numberBangla(row.amount)} টাকা খরচ হয়েছে । খরচের বিস্তারিত নিম্নরূপ
                    </div>

                    <div>

                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th width="60" class="text-center">ক্রমিক</th>
                                    <th class="text-center" width="80">লেজের</th>
                                    <th>দ্রব্যের নাম</th>
                                    <th width="80" class="pl-2 pr-2 text-right">পরিমান</th>
                                    <th class="text-right" width="80">একক</th>
                                    <th width="120" class="text-right pr-3">মূল্য</th>
                                </tr>
                            </thead>

                            <tbody>`;

    row.details.forEach((detail, i) => {
        htmlString += `<tr>
                <td class="text-center pt-1 pb-1">${serBangla(i + 1)}</td>
                <td class="pt-1 pb-1 pl-3 pr-3"></td>
                <td class="pt-1 pb-1 pl-3 pr-3">${detail.name}</td>
                <td class="pt-1 pb-1 pr-3 text-right">${serBangla(detail.qty)}</td>
                <td class="pt-1 pb-1 pr-3 text-right">${detail.unit}</td>
                <td class="pt-1 pb-1 text-right pr-3">${numberFormatBDT(detail.total)}</td>
            </tr>`;
    });

    htmlString += `</tbody>
                            <tfoot>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2" class="text-right pr-3 text-bold">সর্বমোট</td>
                                    <td class="text-right pr-3 text-bold">${numberFormatBDT(row.amount)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <p class="pb-3">
                        কথায়: <b>${BanglaNumberToWords(row.amount)}</b>
                    </p>

                    <div class="mt-3 mb-3">
                        ২। উপরোক্ত ${numberFormatBDT(row.amount)} (${BanglaNumberToWords(row.amount)} ) ${row.ledger_bangla} হতে পরিশোধের নিমিত্তে কমান্ড্যান্ট মহোদয়ের
                        সদয় অনুমোদনের জন্য উপস্থাপন করা হলো
                    </div>

                    ${approvalsHtml(approvals, row.date)}
                    </div>
                    </div>
                </div>`;

    return htmlString;
};

export const printOption = [
    { name: "A4", value: "A4" },
    { name: "A4 landscape", value: "A4 landscape" },
    { name: "Letter", value: "Letter" },
    { name: "Letter landscape", value: "Letter landscape" },
    { name: "Legal", value: "Legal" },
    { name: "Legal landscape", value: "Legal landscape" },
];

export const onPageSizeChange = (page_size) => {
    console.log(page_size);
    var style = document.createElement("style");
    style.innerHTML = `@page {size: ${page_size}}`;
    document.head.appendChild(style);
};

export const dateFormat = (date, format = "DD MMM YYYY") => {
    return moment(date).format(format);
};

export const dateFormatBD = (date, day = "numeric", month = "short", year = "numeric") => {
    if (date) {
        return new Date(date).toLocaleDateString("bn-BD", {
            day: day,
            month: month,
            year: year,
        });
    } else return 0.0;
};

export const monthYearBangla = (date) => {
    if (date) {
        let obj = {
            0: "০",
            1: "১",
            2: "২",
            3: "৩",
            4: "৪",
            5: "৫",
            6: "৬",
            7: "৭",
            8: "৮",
            9: "৯",
            Jan: "জানুয়ারী",
            Feb: "ফেব্রুয়ারী",
            Mar: "মার্চ",
            Apr: "এপ্রিল",
            May: "মে",
            Jun: "জুন",
            Jul: "জুলাই",
            Aug: "আগষ্ট",
            Sep: "সেপ্টেম্বর",
            Oct: "অক্টোবর",
            Nov: "নভেম্বর",
            Dec: "ডিসেম্বর",
            ":": ":",
            ",": ",",
        };

        let retStr = moment(date).format("MMM YYYY");

        for (let x in obj) {
            retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
        }
        return retStr;
    }
};

export const dateYearBangla = (date) => {
    if (date) {
        let obj = {
            Jan: "জানুয়ারী",
            Feb: "ফেব্রুয়ারী",
            Mar: "মার্চ",
            Apr: "এপ্রিল",
            May: "মে",
            Jun: "জুন",
            Jul: "জুলাই",
            Aug: "আগষ্ট",
            Sep: "সেপ্টেম্বর",
            Oct: "অক্টোবর",
            Nov: "নভেম্বর",
            Dec: "ডিসেম্বর",
            ":": ":",
            ",": ",",
        };

        let retStr = moment(date).format("YYYY");

        for (let x in obj) {
            retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
        }
        return retStr;
    }
};

export const banglaDateMonth = (date) => {
    if (date) {
        let obj = {
            0: "০",
            1: "১",
            2: "২",
            3: "৩",
            4: "৪",
            5: "৫",
            6: "৬",
            7: "৭",
            8: "৮",
            9: "৯",
            Jan: "জানুয়ারী",
            Feb: "ফেব্রুয়ারী",
            Mar: "মার্চ",
            Apr: "এপ্রিল",
            May: "মে",
            Jun: "জুন",
            Jul: "জুলাই",
            Aug: "আগষ্ট",
            Sep: "সেপ্টেম্বর",
            Oct: "অক্টোবর",
            Nov: "নভেম্বর",
            Dec: "ডিসেম্বর",
            ":": ":",
            ",": ",",
        };

        let retStr = moment(date).format("DD MMM");

        for (let x in obj) {
            retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
        }
        return retStr;
    }
};

export const dateTimeBangla = (date) => {
    if (date) {
        let obj = {
            0: "০",
            1: "১",
            2: "২",
            3: "৩",
            4: "৪",
            5: "৫",
            6: "৬",
            7: "৭",
            8: "৮",
            9: "৯",
            Jan: "জানুয়ারী",
            Feb: "ফেব্রুয়ারী",
            Mar: "মার্চ",
            Apr: "এপ্রিল",
            May: "মে",
            Jun: "জুন",
            Jul: "জুলাই",
            Aug: "আগষ্ট",
            Sep: "সেপ্টেম্বর",
            Oct: "অক্টোবর",
            Nov: "নভেম্বর",
            Dec: "ডিসেম্বর",
            ":": ":",
            ",": ",",
        };

        let retStr = moment(date).format("DD MMM YY -> HHmm");

        for (let x in obj) {
            retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
        }
        return retStr;
    }
};

export const serBangla = (str) => {
    if (str) {
        let obj = { 0: "০", 1: "১", 2: "২", 3: "৩", 4: "৪", 5: "৫", 6: "৬", 7: "৭", 8: "৮", 9: "৯", ":": ":", ",": ",", ".": ".", "-": "-", " ": " " };

        let banglaStr = String(str)
            .split("")
            .map((x, i) => {
                return obj[x];
            })
            .join("");

        return banglaStr;
    } else return 0;
};

export const numberFormat = (value, decimal = 2) => {
    if (value) {
        return Number(value)
            .toFixed(decimal)
            .replace(/\d(?=(\d{5})+\.)/g, "$&,")
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else return 0.0;
};

export const numberFormatBDT = (number, currency = "BDT") => {
    if (number) {
        return Number(number).toLocaleString("bn-BD", { style: "currency", currency: currency });
    }
};

export const numberBangla = (value, decimal = 2) => {
    if (value) {
        let str = Number(value)
            .toFixed(decimal)
            .replace(/\d(?=(\d{5})+\.)/g, "$&,")
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");

        let obj = { 0: "০", 1: "১", 2: "২", 3: "৩", 4: "৪", 5: "৫", 6: "৬", 7: "৭", 8: "৮", 9: "৯", ":": ":", ",": ",", ".": ".", " ": " ", "-": "-" };

        let banglaStr = String(str)
            .split("")
            .map((x, i) => {
                return obj[x];
            })
            .join("");

        return banglaStr;
    } else return 0.0;
};

export const numberToWords = (number) => {
    var NS = [
        { value: 10000000, str: "Crore" },
        { value: 100000, str: "Lakh" },
        { value: 1000, str: "Thousand" },
        { value: 100, str: "Hundred" },
        { value: 90, str: "Ninety" },
        { value: 80, str: "Eighty" },
        { value: 70, str: "Seventy" },
        { value: 60, str: "Sixty" },
        { value: 50, str: "Fifty" },
        { value: 40, str: "Forty" },
        { value: 30, str: "Thirty" },
        { value: 20, str: "Twenty" },
        { value: 19, str: "Nineteen" },
        { value: 18, str: "Eighteen" },
        { value: 17, str: "Seventeen" },
        { value: 16, str: "Sixteen" },
        { value: 15, str: "Fifteen" },
        { value: 14, str: "Fourteen" },
        { value: 13, str: "Thirteen" },
        { value: 12, str: "Twelve" },
        { value: 11, str: "Eleven" },
        { value: 10, str: "Ten" },
        { value: 9, str: "Nine" },
        { value: 8, str: "Eight" },
        { value: 7, str: "Seven" },
        { value: 6, str: "Six" },
        { value: 5, str: "Five" },
        { value: 4, str: "Four" },
        { value: 3, str: "Three" },
        { value: 2, str: "Two" },
        { value: 1, str: "One" },
    ];

    var result = "";
    for (var n of NS) {
        if (number >= n.value) {
            if (number <= 99) {
                result += n.str;
                number -= n.value;
                if (number > 0) result += " ";
            } else {
                var t = Math.floor(number / n.value);
                // console.log(t);
                var d = number % n.value;
                if (d > 0) {
                    return numberToWords(t) + " " + n.str + " " + numberToWords(d);
                } else {
                    return numberToWords(t) + " " + n.str;
                }
            }
        }
    }
    return result;
};

export const BanglaNumberToWords = (number) => {
    let Words = [
        "",
        "এক",
        "দুই",
        "তিন",
        "চার",
        "পাঁচ",
        "ছয়",
        "সাত",
        "আট",
        "নয়",
        "দশ",
        "এগার",
        "বার",
        "তের",
        "চৌদ্দ",
        "পনের",
        "ষোল",
        "সতের",
        "আঠার",
        "ঊনিশ",
        "বিশ",
        "একুশ",
        "বাইশ",
        "তেইশ",
        "চব্বিশ",
        "পঁচিশ",
        "ছাব্বিশ",
        "সাতাশ",
        "আঠাশ",
        "ঊনত্রিশ",
        "ত্রিশ",
        "একত্রিশ",
        "বত্রিশ",
        "তেত্রিশ",
        "চৌত্রিশ",
        "পঁয়ত্রিশ",
        "ছত্রিশ",
        "সাঁইত্রিশ",
        "আটত্রিশ",
        "ঊনচল্লিশ",
        "চল্লিশ",
        "একচল্লিশ",
        "বিয়াল্লিশ",
        "তেতাল্লিশ",
        "চুয়াল্লিশ",
        "পঁয়তাল্লিশ",
        "ছেচল্লিশ",
        "সাতচল্লিশ",
        "আটচল্লিশ",
        "ঊনপঞ্চাশ",
        "পঞ্চাশ",
        "একান্ন",
        "বায়ান্ন",
        "তিপ্পান্ন",
        "চুয়ান্ন",
        "পঞ্চান্ন",
        "ছাপ্পান্ন",
        "সাতান্ন",
        "আটান্ন",
        "ঊনষাট",
        "ষাট",
        "একষট্টি",
        "বাষট্টি",
        "তেষট্টি",
        "চৌষট্টি",
        "পঁয়ষট্টি",
        "ছেষট্টি",
        "সাতষট্টি",
        "আটষট্টি",
        "ঊনসত্তর",
        "সত্তর",
        "একাতর",
        "বাহাত্তর",
        "তিয়াত্তর",
        "চুয়াত্তর",
        "পঁচাত্তর",
        "ছিয়াত্তর",
        "সাতাত্তর",
        "আটাত্তর",
        "ঊনআশি",
        "আশি",
        "একাশি",
        "বিরাশি",
        "তিরাশি",
        "চুরাশি",
        "পঁচাশি",
        "ছিয়াশি",
        "সাতাশি",
        "আটাশি",
        "ঊননব্বই",
        "নব্বই",
        "একানব্বই",
        "বিরানব্বই",
        "তিরানব্বই",
        "চুরানব্বই",
        "পঁচানব্বই",
        "ছিয়ানব্বই",
        "সাতানব্বই",
        "আটানব্বই",
        "নিরানব্বই",
    ];

    if (!number) return;
    number = number.toString();
    let atemp = number.split(".");
    let before_word = "";
    let after_word = "";
    let before_number = atemp[0];

    if (before_number !== "0") before_word = toWord(before_number, Words);

    if (atemp.length === 2) {
        let after_number = atemp[1];

        after_word = toWord(after_number, Words);
        if (before_word !== "" && after_number > 0) {
            before_word += " দশমিক " + after_word;
        } else if (after_number > 0) {
            before_word += "দশমিক " + after_word;
        }
    }

    return (before_word += " টাকা মাত্র");
};

const toWord = (number, words) => {
    let n_length = number.length;
    let words_string = "";

    if (n_length <= 9) {
        let n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let received_n_array = new Array();
        for (let i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (let i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i == 7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 2) {
                    n_array[j] = 20 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 3) {
                    n_array[j] = 30 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 4) {
                    n_array[j] = 40 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 5) {
                    n_array[j] = 50 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 6) {
                    n_array[j] = 60 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 7) {
                    n_array[j] = 70 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 8) {
                    n_array[j] = 80 + parseInt(n_array[j]);
                    n_array[i] = 0;
                } else if (n_array[i] == 9) {
                    n_array[j] = 90 + parseInt(n_array[j]);
                    n_array[i] = 0;
                }
            }
        }

        let value = "";
        for (let i = 0; i < 9; i++) {
            value = n_array[i];
            if (value != 0) {
                words_string += words[value] + "";
            }
            if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
                words_string += " কোটি ";
            }
            if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
                words_string += " লাখ ";
            }
            if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
                words_string += " হাজার ";
            } else if (i == 6 && value != 0) {
                words_string += "শ ";
            }
        }

        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
};
